import styled from 'styled-components';
import { color, container, screen, spacing, zindex } from 'theme';

export const StyledBottomBar = styled.div`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${zindex('bottomBar')};
  background-color: ${color('midnight_900')};
  color: ${color('text_default_inverse')};
  transform: translateY(100%);
  transition: opacity 0.2s;
  margin-top: -3.5rem;
  padding-top: ${spacing('xs')};
  padding-bottom: ${spacing('xs')};

  @keyframes ShowBar {
    to {
      transform: translateY(0);
    }
  }

  &.is-scroll {
    animation: ShowBar 0.5s 1.5s forwards;
  }

  &.is-detached {
    opacity: 0;
    pointer-events: none;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-width: ${container('xlMax')};
  padding-right: ${spacing('sm')};
  padding-left: ${spacing('sm')};
  margin: auto;
  overflow: hidden;

  @media (min-width: ${screen('md')}) {
    justify-content: flex-end;
  }
`;
